// extracted by mini-css-extract-plugin
export default {"container":"information-principal_container__IVSjj","container-signatory":"information-principal_container-signatory__f1y4t","title":"information-principal_title__PJS5m"};